import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const ThreeByTwo = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === '3x2');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default ThreeByTwo;
